import { InjectionToken } from '@angular/core'
import { BenefitEnvironment } from './environment-config.model'

export const BENEFIT_ENVIRONMENT = new InjectionToken<BenefitEnvironment>(
    'ENVIRONMENT',
)
